import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import { common, createLowlight } from "lowlight";
import { TextSelection } from "@tiptap/pm/state";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CodeBlockNodeView } from "./CodeBlockNodeView";

/**
 * Create lowlight instance with common languages
 */
const lowlight = createLowlight(common);

/**
 * CodeBlock extension with syntax highlighting using lowlight
 * Extends the base CodeBlockLowlight extension with custom configuration
 */
export const CodeBlockWithLowlight = CodeBlockLowlight.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      language: {
        default: "plaintext",
        parseHTML: (element) => {
          const language = element.getAttribute("data-language");
          return language || "plaintext";
        },
        renderHTML: (attributes) => {
          return {
            "data-language": attributes.language,
            class: `language-${attributes.language}`,
          };
        },
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockNodeView);
  },

  addKeyboardShortcuts() {
    return {
      // Toggle code block with Mod-Alt-C
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),

      // Exit code block with Mod-Enter
      "Mod-Enter": () => {
        if (!this.editor.isActive("codeBlock")) {
          return false;
        }

        return this.editor
          .chain()
          .command(({ tr }) => {
            const { $from } = tr.selection;
            const after = $from.after();

            if (after === undefined) {
              return false;
            }

            const $after = tr.doc.resolve(after);
            tr.setSelection(TextSelection.near($after));

            return true;
          })
          .insertContent({ type: "paragraph" })
          .run();
      },

      // Tab indentation (insert 2 spaces)
      "Tab": () => {
        if (!this.editor.isActive("codeBlock")) {
          return false;
        }

        return this.editor.commands.insertContent("  ");
      },
    };
  },
}).configure({
  lowlight,
  defaultLanguage: "plaintext",
  HTMLAttributes: {
    class: "code-block",
  },
});
